import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { APP_BASE_HREF } from '@angular/common';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

import { langsPath } from '@unpispas/upp-base';
import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { FeatureLoginModule } from '@unpispas/feature/login';
import { FeatureUserModule } from '@unpispas/feature/user';
import { FeatureTopbarModule } from '@unpispas/feature/topbar';
import { FeaturePinpadModule } from '@unpispas/feature/pinpad';
import { FeatureTicketModule } from '@unpispas/feature/ticket';
import { FeatureQrCodeModule } from '@unpispas/feature/qrcode';
import { FeatureProductModule } from '@unpispas/feature/product';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { PtfPlaceShellComponent } from './place/ptf-place-shell';
import { PtfCartComponent } from './place/ptf-cart';
import { PtfTicketsComponent } from './place/ptf-tickets';

@NgModule({
  declarations: [
    AppComponent,
    PtfPlaceShellComponent,
    PtfCartComponent,
    PtfTicketsComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    ReactiveFormsModule,
    UppBaseModule,
    UppWdgtModule,
    FeatureLoginModule,
    FeatureUserModule,
    FeatureTopbarModule,
    FeaturePinpadModule,
    FeatureTicketModule,
    FeatureQrCodeModule,
    FeatureProductModule,
    IonicModule.forRoot(),
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: document.querySelector('base')?.getAttribute('href') || '/' },
    { provide: langsPath, useFactory: (baseHref: string) => `${baseHref}lang`, deps: [APP_BASE_HREF] },
    Geolocation,
    AndroidPermissions,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
